import { MAP_UPDATEGEOLOCATION } from "../Actions/GoogleMap.action";
let initialState = {
  Address: "",
  AgentName: "",
  Coordinates: "",
  Email: "",
  Phone: "",
  isOpen: false,
  latitude: "",
  longitude: "",
  ResellerWebsiteUrl:"",
};
export const googlemap = (state = initialState, action) => {
  switch (action.type) {
    case MAP_UPDATEGEOLOCATION:
      const cordinatesDetails = action.payload.Coordinates.split(",");
      return {
        ...state,
        Address: action.payload.Address,
        AgentName: action.payload.AgentName,
        Coordinates: action.payload.Coordinates,
        Email: action.payload.Email,
        Phone: action.payload.Phone,
        latitude: parseFloat(cordinatesDetails[0]),
        longitude: parseFloat(cordinatesDetails[1]),
        isOpen: true,
        ResellerWebsiteUrl: action.payload.ResellerWebsiteUrl,
      };
    default:
      return state;
  }
};
